import {StageLayer} from "@nolimit/slot-launcher/bin/StageLayer";
import {gsap, TweenLite} from "gsap";
import {ContinueButton} from "@nolimit/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {FITH2SoundManager} from "../sound/FITH2SoundManager";
import {FITH2SoundConfig} from "../configs/FITH2SoundConfig";
import {FireInTheHole2} from "../FireInTheHole2";
import {BasicBitmapCountUp} from "../components/BasicBitmapCountUp";
import {FITH2GameAssets} from "../FITH2GameAssets";
import {SpineTween} from "@nolimit/slot-game/bin/animation/SpineTween";
import {NolimitApplication} from "@nolimit/slot-launcher/bin/NolimitApplication";
import {FITH2Helper} from "../utils/FITH2Helper";
import {FITH2WinConfig} from "../configs/FITH2WinConfig";
import {FontWeight} from "@nolimit/slot-launcher/bin/loader/font/FontStatics";
import {IFITH2GameData} from "../server/IFITH2Data";
import {MathHelper} from "@nolimit/slot-game/bin/utils/MathHelper";

export class FITH2FreespinOutro extends PIXI.Container implements StageLayer {
    private _spine: PIXI.spine.Spine | null;
    private _spineContainer: PIXI.Sprite;
    private _button: ContinueButton;
    private _spinsPlayedText: PIXI.Text;
    private _youWonLabel: PIXI.Text;
    private _spinsPlayedNr: PIXI.Text;

    private _multiplier: PIXI.Text;
    private _clickCallback: () => void;
    private _countUp: BasicBitmapCountUp;
    private _spinsPlayedTextStyle = {
        fill: "#ff7800",
        fontFamily: "Open Sans",
        fontSize: 34,
        fontWeight: FontWeight.EXTRA_BOLD,
        padding : 10
    };

    constructor() {
        super();
        this.name = "FreespinOutro";
        this.init();
    }

    private onButtonClick(playClickSound: boolean): void {
        if (playClickSound) {
            FITH2SoundManager.playSound(FITH2SoundConfig.CONTINUE_BUTTON);
        }
        const hideFSOuttroTL = gsap.timeline();
        hideFSOuttroTL.add(() => {
            FireInTheHole2.keypadPlugin.hide();
            this._button.enable(false);
            this._clickCallback();
            this._clickCallback = () => {
            };
        });

        if (playClickSound) {
            hideFSOuttroTL.add(FireInTheHole2.gameViewContainer.scaleUp());
            hideFSOuttroTL.add([
                FireInTheHole2.gameViewContainer.removeDimmer(),
                FireInTheHole2.multiplier.update(1),
                TweenLite.to(this, 0.2, {alpha: 0}),
                TweenLite.to(this._button, 0.2, {alpha: 0})
            ], 0.2);
        } else {
            //cap win
            hideFSOuttroTL.add(() => {
                this.alpha = 0;
                this._button.alpha = 0;
            });
        }

        hideFSOuttroTL.add(() => {
            this.visible = false;
            this._spineContainer.removeChildren();
            FireInTheHole2.fsLeftView.update(3);
        });
    }

    public onResize(): void {
        this._button.position.set(360, Math.max(530, NolimitApplication.screenBounds.bottom - 180));
    }

    private createYouWonText(): PIXI.Text {
        const textStyle: PIXI.TextStyle = new PIXI.TextStyle({
                fill: "#ffffff",
                fontFamily: "Open Sans",
                fontSize: 36,
                fontWeight: FontWeight.EXTRA_BOLD,
                padding: 10
            }),
            youWon: PIXI.Text = new PIXI.Text(FireInTheHole2.apiPlugin.translations.translate("YOU WON"), textStyle);

        youWon.position.x = 347;
        youWon.position.y = 168;
        youWon.anchor.set(0.5);
        youWon.scale.set(MathHelper.roundToDecimals(Math.min(280 / youWon.width, 1), 1));
        youWon.visible = false;
        return youWon;
    }

    private init(): void {
        this._spineContainer = new PIXI.Sprite();
        this.addChild(this._spineContainer);
        this._spineContainer.position.set(360, 360);
        this._button = new ContinueButton();
        this._button.addClickCallback(() => this.onButtonClick(true));
        this._button.position.set(360, 530);
        this._button.pivot.set(this._button.width * 0.5, 0);
        this._button.enable(false);
        this._button.alpha = 0;

        this._multiplier = new PIXI.Text("x", {
            fill: "#ff7800",
            fontFamily: "Marion",
            fontSize: 50,
            fontWeight: FontWeight.BOLD
        });
        this._spinsPlayedText = new PIXI.Text("x", this._spinsPlayedTextStyle);
        this._multiplier.visible = false;
        this._spinsPlayedText.visible = false;
        this._multiplier.anchor.set(0.5);
        this._spinsPlayedText.anchor.set(0.5);
        this._multiplier.position.set(360, 240);
        this._spinsPlayedText.position.set(360, 465);
        this._youWonLabel = this.createYouWonText();

        this.addChild(this._multiplier, this._spinsPlayedText, this._youWonLabel);

        this._spinsPlayedNr = new PIXI.Text("22", this._spinsPlayedTextStyle);
        this._spinsPlayedNr.visible = false;
        this.addChild(this._spinsPlayedNr);

        this.addChild(this._button);

        this._countUp = new BasicBitmapCountUp({
            fontName: FITH2GameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 40,
            tint: 0xffffff
        }, 520, new PIXI.Point(0.5, 0.5));
        this._countUp.position.set(360, 350);
        this._countUp.stopAt(0);
        this.visible = false;
        this.addChild(this._countUp);
        this.visible = false;
    }

    public show(callback: () => void, isReplay: boolean = false): gsap.core.Timeline {
        const tl = gsap.timeline(),
            gameData: IFITH2GameData = FireInTheHole2.model.gameData,
            totalWin: number = gameData.accumulatedRoundWin,
            totalMultiplier: number = FireInTheHole2.multiplier.currentMultiplierValue,
            isZeroWin: boolean = (totalWin === 0),
            startPoint: number = FireInTheHole2.model.hasNoAvalancheWin ? 2 : 0;
        if (this._spine) {
            this._spine.destroy();
            this._spine = null;
        }
        this._spine = new PIXI.spine.Spine(FireInTheHole2.assetLoader.getSpineAsset("FS_Outro"));
        this._spineContainer.addChild(this._spine);
        this._youWonLabel.visible = false;
        this.onResize();
        tl.add(() => {
            FireInTheHole2.fsLeftView.update(0);
            this._clickCallback = callback;
        });
        //Add no win delay
        tl.add(() => {
        }, startPoint);
        this._spinsPlayedText.position.y = isZeroWin ? 289 : 465;
        this._countUp.visible = false;
        if (gameData && gameData.brokeTheBank) {
            this.onButtonClick(false);
        } else {
            const soundTimeline: gsap.core.Timeline = new gsap.core.Timeline().add(() => FITH2SoundManager.playAmbientLoop(), 0.527);
            tl.add([
                soundTimeline,
                FireInTheHole2.gameViewContainer.addDimmer(true, 0.2, 0.5),
                new SpineTween(this._spine, 0, "in"),
                () => {
                    FireInTheHole2.keypadPlugin.hide();
                    this._spinsPlayedText.text = FireInTheHole2.apiPlugin.translations.translate(`Spins played`);
                    this._spinsPlayedNr.text = `${FireInTheHole2.model.gameData.freespinsPlayed}`;
                    this._spinsPlayedNr.position.set(360 - this._spinsPlayedNr.width * 0.5, isZeroWin ? 360 : 486);
                    this.visible = true;
                    this.alpha = 1;
                    if (totalMultiplier >= 1) {
                        this._multiplier.text = FireInTheHole2.apiPlugin.currency.format(gameData?.playedBetValue!) + " x " + FireInTheHole2.multiplier.currentMultiplierValue;
                        this._multiplier.visible = true;
                    }

                    this._spinsPlayedText.visible = true;
                    this._spinsPlayedNr.visible = true;
                    FITH2SoundManager.playSound(FITH2SoundConfig.FREESPIN_OUTRO, 0);
                }], startPoint);

            tl.add([

                TweenLite.to(this._spinsPlayedNr, 0.1, {alpha: 1}),
                TweenLite.to(this._spinsPlayedText, 0.1, {alpha: 1}),
            ]);
            if (!isZeroWin) {
                let winType: string = FITH2WinConfig.getWinConfig().type;
                const isWinBelowStake: boolean = FITH2Helper.isWinBelowStake();
                const hasCountUp: boolean = !isWinBelowStake && (winType === FITH2WinConfig.LARGE || winType === FITH2WinConfig.MEDIUM);
                tl.add(() => {
                    this._countUp.stopAt(0);
                    this._countUp.scale.set(0.5, 0.5);
                    this._countUp.alpha = 0;
                    this._countUp.visible = true;
                });

                tl.add([
                    () => {
                        this._youWonLabel.visible = !isWinBelowStake;
                    },
                    TweenLite.to(this._countUp, 0.1, {alpha: 1}),
                    TweenLite.to(this._countUp.scale, 0.1, {x: 1, y: 1, ease: "sine.in"}),
                    this._countUp.getCountAnimation(0, totalWin, hasCountUp ? 0.5 : 0)
                ]);
                if (hasCountUp) {
                    tl.add(() => {
                        FITH2SoundManager.playSound(`fsEndsCountupEnds`);
                    });
                }
            }

            tl.add([
                () => {
                    this._spine!.state.setAnimation(0, "base", true);
                },
                TweenLite.to(this._button, 0.4, {alpha: 1})
            ]);
            tl.add([
                () => {
                    this._button.enable(true);
                }]);
        }
        return tl;
    }
}